/* eslint-disable jsx-a11y/media-has-caption */
import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {getTheme, getThemeStyles} from '../util/theme'
import {getLanguageCode} from '../util/locale'
import {getBrowser, isBrowserUnsupported, isMobileAndTablet} from '../util/userAgent'

import Layout from '../components/Layout'
import MobileDirections from './add-startpage-com-to-your-home-screen'
import Instructions from '../components/Instructions'
import MakeHomePageSvgLight from '../images/make-sp--light.svg'
import MakeHomePageSvgDark from '../images/make-sp--dark.svg'

import makeHomepageData from '../translations/make-homepage.json'

const MakeHomepage = ({languageCode}) => {
    const lang = languageCode || getLanguageCode()

    const makeHomepage = makeHomepageData[lang]

    const {title: pageTitle, chromeInstructions} = makeHomepage

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})
    const [browserType, setBrowserType] = useState('chrome')
    // default to chrome instructions
    const [pageContent, setPageContent] = useState(chromeInstructions)

    useEffect(() => {
        if (isBrowserUnsupported()) {
            // redirect to the support page article with instructions per browser
            window.location.href =
                'https://support.startpage.com/index.php?/Knowledgebase/Article/View/892/0/how-do-i-make-startpage-my-homepage'
            return
        }
        const theme = getTheme()
        const themeStyles = getThemeStyles()
        setBrowserType(getBrowser())
        const browserSpecificInstructions = makeHomepage[`${browserType}Instructions`]
        if (browserSpecificInstructions) {
            setPageContent(browserSpecificInstructions)
        }
        setTheme(theme)
        setThemeStyles(themeStyles)
    }, [themeStyles, pageContent, makeHomepage, browserType])

    const renderSvg = () => {
        switch (theme) {
            case 'light':
                return <MakeHomePageSvgLight />
            case 'air':
                return <MakeHomePageSvgLight />
            case 'night':
                return <MakeHomePageSvgDark />
            case 'dark':
                return <MakeHomePageSvgDark />
            default:
                return <MakeHomePageSvgLight />
        }
    }

    const renderComponent = () => {
        if (isBrowserUnsupported()) {
            return <div>loading...</div>
        }
        if (isMobileAndTablet()) {
            return <MobileDirections languageCode={lang} />
        }
        return (
            <Layout
                title={pageTitle}
                description={pageContent && pageContent[0].title}
                lang={lang}
                canonicalPath="/make-homepage/"
                themeStyles={themeStyles}
                theme={theme}
            >
                <div
                    css={css`
                        min-height: calc(100vh - 192px);
                        padding: 8.5rem 2rem 4rem;
                        background: ${themeStyles.lighterBackgroundColor};
                    `}
                >
                    <div
                        className="inner"
                        css={css`
                            max-width: 1200px;
                            margin: auto;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            @media (max-width: 1100px) {
                                justify-content: center;
                            }
                        `}
                    >
                        <Instructions
                            content={pageContent}
                            themeStyles={themeStyles}
                            title={pageTitle}
                            browserType={browserType}
                        />
                        <div
                            css={css`
                                margin: 0 0 0 1rem;
                                svg {
                                    width: 100%;
                                    @media (max-width: 1100px) {
                                        display: none;
                                    }
                                }
                            `}
                        >
                            {renderSvg()}
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    return renderComponent()
}

MakeHomepage.propTypes = {
    languageCode: PropTypes.string,
}

export default MakeHomepage
